import { Engine, Actor, Color, Vector, CollisionType, Animation, SpriteSheet, vec } from 'excalibur';
import { Resources } from '../../resources';
import { collision_groups } from '../../scenes/level-one/collision_groups';
import { LevelOne } from '../../scenes/level-one/level-one';
import { range } from '../../util';
import { Enemy } from './enemy';

export class DiamondShark extends Enemy {
    constructor(
        level: LevelOne,
    ) {
        super(
            level,
            350,
            1,
            Animation.fromSpriteSheet(
                SpriteSheet.fromImageSource({
                    image: Resources.diamondSharkSide,
                    grid: {
                        rows: 3,
                        columns: 5,
                        spriteWidth: 650,
                        spriteHeight: 250,
                    },

                }),
                range(0, 14),
                57
            ),
            Animation.fromSpriteSheet(
                SpriteSheet.fromImageSource({
                    image: Resources.diamondSharkTop,
                    grid: {
                        rows: 3,
                        columns: 4,
                        spriteWidth: 326,
                        spriteHeight: 565,
                    },

                }),
                range(0, 11),
                40
            )
        );
    }
}

export { Enemy }
